import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgwWowService } from 'ngx-wow';
import { Subscription }   from 'rxjs/Subscription';
import { filter } from 'rxjs/operators';
import { MetaDataService } from '../../../services/meta-data.service';
import 'rxjs/Rx';
import { ServerConstants } from 'src/app/constants/server-constants';

import { fromEvent } from 'rxjs';
import { BackendService } from '../../../services/backend.service';
import { ToastrService } from 'ngx-toastr';


declare var $:any;
var _this;

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {

  private wowSubscription: Subscription;
  public nutraLink: string;
  formSubmitted = false;
  termcondition = false;
  isTermconditionAccepted = false;
  @ViewChild('termconditions', {static: false}) termconditions;

  user: any = {};
  iPAddress;
  @ViewChild('registerForm', {static: false}) registerForm;

  lottieConfig = {
    path: 'assets/lottie/jigsawwhite.json',
    renderer: 'canvas',
    autoplay: true,
    loop: true
  };

  constructor(private wowService: NgwWowService, private router: Router, private meta :MetaDataService, private backendService: BackendService, private toastr: ToastrService) {
    _this = this;
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
    });
  }

  ngOnInit() {
    this.meta.updateMetaTags({
      title: 'Inventia Healthcare Limited',
      desc: 'Filling the Gaps in your Product Portfolio. With 30+ years of experience in Oral Solid Dosage. New High Growth verticals of Nutraceuticals and Injectables.'
    });
    this.nutraLink = ServerConstants.NUTRA_URL;

    /*For cookie*/
    // setTimeout(function(){
    //   let popup = document.getElementsByClassName("cookie-policy");
    //   popup[0].classList.add("open");
    // }, 1500);
    this.getIPAddress();
  }

  getIPAddress(){
    this.backendService.getIPAddress()
    .subscribe(result => {
      this.iPAddress = result.ip;
    },
    error => {
    });
  }

  closePopUp(){
    let popup = document.getElementsByClassName("cookie-policy");
    popup[0].classList.remove("open");
  }

  submitPopUp(){
    let timeStamp = new Date().getTime();
    this.backendService.acceptCookie({
      ip: this.iPAddress,
      timestamp: timeStamp
    })
    .subscribe(result => {
      if(result.code == 200) {
        this.closePopUp();
      }
    },
    error => {
    });
  }

  openVideo(){
    let video = <HTMLVideoElement> document.getElementById('video1');
    video.play();
    $('#exampleModal').on('hidden.bs.modal', function () {
        _this.stopVideo('video1');
    });
  }

  openTherapeuticVideo(){
    let video = <HTMLVideoElement> document.getElementById('video2');
    video.play();
    $('#therapeuticVideoModal').on('hidden.bs.modal', function () {
        _this.stopVideo('video2');
    });
  }

  stopVideo(id){
    let video = <HTMLVideoElement> document.getElementById(id);
    video.pause();
    video.currentTime = 0;
  }

  markFormAsDirty() {
    Object.keys(this.registerForm.controls).forEach(key => {
      this.registerForm.controls[key].markAsDirty();
    });
  }

  saveHomePageEmail(value: any){
    this.markFormAsDirty();
    this.termconditions.control.markAsDirty();
    if(this.registerForm.form.valid && this.isTermconditionAccepted) {
      this.formSubmitted = true;
      this.backendService.saveHomePageEmail(value)
      .subscribe(result => {
        this.formSubmitted = false;
        if (result == 'Email sent') {
          this.user = {};
          this.registerForm.form.reset();
          this.toastr.success('Submitted successfully!');
        }
      },
      error => {
        this.formSubmitted = false;
        this.toastr.success('Something went wrong!');
      });
    }
  }

  acceptTermsAndCondition() {
    this.isTermconditionAccepted = !this.isTermconditionAccepted;
  }
}
